import { render, staticRenderFns } from "./trailerCard.vue?vue&type=template&id=23e030ec&"
import script from "./trailerCard.vue?vue&type=script&lang=js&"
export * from "./trailerCard.vue?vue&type=script&lang=js&"
import style0 from "./trailerCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports